/**
 * Type-safe mode-aware navigation helper for visitor routes.
 * Returns the right shape for TanStack Router's navigate() — preserving
 * compile-time type safety on both route variants.
 */
import { detectTenant } from "../hooks/use-tenant";

export function visitorNavigateArgs(orgSlug: string, mapSlug: string) {
  const tenant = detectTenant();
  if (tenant.mode === "subdomain" || tenant.mode === "custom_domain") {
    return { to: "/$mapSlug" as const, params: { mapSlug } };
  }
  return { to: "/$orgSlug/$mapSlug" as const, params: { orgSlug, mapSlug } };
}
